import React from 'react'
import { Field, ErrorMessage } from "formik";
import Select from "react-select";
import { selectStylesField } from '../../utils';

const SelectField = ({ form, field, label_text, filterOption, placeholder, smaller, options, isMulti, isDisabled, isRequired,isClearable, isSearchable, openPopup, btn_text, customSelected }) => {
    const handleChange = (value) => {
        form.setFieldValue(field, value);
    }
    return (
        <>
            <div>
                <div className={`relative block w-full group`}>
                    <div className='flex w-full items-end justify-between'>
                        <label className='text-xs font-medium inline-block mb-1'>
                            {label_text}
                            {isRequired && <span className=''>*</span>}
                        </label>
                        {btn_text &&
                            <p
                                className='text-xs font-bold text-primary/80 text-white bg-primary  rounded-md py-1 px-2 cursor-pointer'
                                onClick={()=>openPopup(form)}
                            >
                                {btn_text}
                            </p>}
                    </div>

                    {
                        filterOption ?
                            <Select
                                isSearchable={true}
                                styles={smaller ? selectStylesField(form.touched[field] && form.errors[field]) : selectStylesField(form.touched[field] && form.errors[field])}
                                options={options}
                                value={customSelected ? customSelected : form.values[field]}
                                onChange={handleChange}
                                className="flex-grow field-text-size"
                                placeholder={placeholder ? placeholder : label_text}
                                isDisabled={isDisabled}
                                isMulti={isMulti}
                                isClearable={isClearable}
                                filterOption={(option, searchText) => filterOption(option, searchText)}
                            />
                            :
                            <Select
                                isSearchable={true}
                                styles={smaller ? selectStylesField(form.touched[field] && form.errors[field]) : selectStylesField(form.touched[field] && form.errors[field])}
                                options={options}
                                value={customSelected ? customSelected : form.values[field]}
                                onChange={handleChange}
                                className="flex-grow field-text-size"
                                placeholder={placeholder ? placeholder : label_text}
                                isDisabled={isDisabled}
                                isMulti={isMulti}
                                isClearable={isClearable}
                            />

                    }
                    <p className="text-xs text-red-500">
                        <ErrorMessage name={field} />
                    </p>
                </div>
            </div >
        </>
    )
}

export default SelectField